
(function(){
 function init(){
   var trigger=document.getElementById('dsuk-search-trigger');
   var overlay=document.getElementById('dsuk-search-overlay');
   if(!trigger || !overlay) return;
   function openSearch(ev){
     if(ev){ev.preventDefault();ev.stopPropagation();}
     overlay.classList.add('is-open');
     overlay.style.display='flex';
     overlay.setAttribute('aria-hidden','false');
     var input=overlay.querySelector('input[name="q"]');
     if(input) setTimeout(function(){input.focus();},20);
   }
   function closeSearch(){
     overlay.classList.remove('is-open');
     overlay.style.display='none';
     overlay.setAttribute('aria-hidden','true');
   }
   trigger.onclick=openSearch;
   var close=overlay.querySelector('.dsuk-search-close');
   if(close) close.onclick=closeSearch;
   overlay.addEventListener('click',function(e){if(e.target===overlay)closeSearch();});
   document.addEventListener('keydown',function(e){if(e.key==='Escape')closeSearch();});
 }
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
 else init();
})();
